<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="organizationForm">
      <div class="field" [ngClass]="displayFieldCss('organizationLongName')">
        <label>Long Name </label>
        <input
          formControlName="organizationLongName"
          type="text"
          placeholder="Company Long Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('organizationLongName')"
          errorMsg="Please enter company long name"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('organizationShortName')">
        <label>Short Name </label>
        <input
          formControlName="organizationShortName"
          type="text"
          placeholder="Company Short Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('organizationShortName')"
          errorMsg="Please enter company short name"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('organizationDescription')">
        <label>Description</label>
        <textarea
          rows="2"
          placeholder="Description"
          formControlName="organizationDescription"
        ></textarea>
        <app-field-error-display
          [displayError]="isFieldValid('organizationDescription')"
          errorMsg="Please enter company description"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Back
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="save()"
    autofocus
  >
    Done
  </button>
</div>
